import { FC } from 'react'

import { HeaderProps } from './types'

const Header: FC<HeaderProps> = ({ children, className }) => {
  return (
    <div
      className={`flex w-full flex-col gap-4 justify-center items-center ${className}`}
    >
      {children}
    </div>
  )
}

export default Header
